import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { BsDownload, BsMusicNoteBeamed } from 'react-icons/bs';

const BookingDetails = () => {
    const { id } = useParams();
    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isDownloadingAudio, setIsDownloadingAudio] = useState(false);
    const navigate = useNavigate();
    const token = localStorage?.getItem("astroVani-admin-token");

    const userId = booking?.userId

    const astroId = booking?.astroId;
    const adminData = JSON.parse(localStorage?.getItem("astroVani-admin-data") || "{}");
    const role = adminData?.role;
    const roleStr = typeof role === 'string' ? role : (role?.roleName || '');

    const isSuperAdmin =
        roleStr.toUpperCase().includes('SUPER_ADMIN') ||
        roleStr.toLowerCase().includes('super admin') ||
        Boolean(
            adminData?.email &&
            process.env.REACT_APP_SPECIAL_ADMIN_EMAIL &&
            adminData.email.toLowerCase() ===
            process.env.REACT_APP_SPECIAL_ADMIN_EMAIL.toLowerCase()
        );
    // navigate(`/admin/chat/${userId}/${astroId}`);

    useEffect(() => {
        const fetchBookingDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/booking/${id}`, {
                    headers: { Authorization: token },
                });

                const data = response.data.data;

                // Format bookingTime
                const bookingTimeObj = new Date(data.bookingTime);
                const day = bookingTimeObj.getDate();
                const month = bookingTimeObj.getMonth() + 1;
                const year = bookingTimeObj.getFullYear();
                const hours = bookingTimeObj.getHours();
                const minutes = String(bookingTimeObj.getMinutes()).padStart(2, '0');
                const ampm = hours >= 12 ? 'PM' : 'AM';
                const formattedHour = hours % 12 || 12;
                const formattedTime = `${day}-${month}-${year}, ${formattedHour}:${minutes} ${ampm}`;

                setBooking({
                    ...data,
                    bookingTimeFormatted: formattedTime
                });
            } catch (error) {
                console.error("Error fetching booking details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBookingDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!booking) {
        return (
            <div className="text-center mt-4">
                <h5>No booking details found.</h5>
            </div>
        );
    }


    const formatCamelCase = (str) => {
        if (!str) return '';
        return str
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/^./, (char) => char.toUpperCase());
    };
    const convertSecondsToTime = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${hours} hr ${minutes} min ${seconds} sec`;
    };

    const handleDownloadAudio = async (url) => {
        if (!url) {
            toast.error("Audio URL not found");
            return;
        }
        setIsDownloadingAudio(true);
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch audio file");
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            const baseName = url.split('/').pop().split('?')[0] || `booking_audio_${booking?.orderId || 'recording'}.mp3`;
            const filename = baseName.endsWith('.mp3') || baseName.endsWith('.wav') || baseName.endsWith('.m4a') || baseName.endsWith('.aac')
                ? baseName
                : `${baseName}.mp3`;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
            toast.success("Audio downloaded successfully");
        } catch (error) {
            console.error("Direct download failed, opening link fallback:", error);
            try {
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.download = `booking_audio_${booking?.orderId || 'recording'}.mp3`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                toast.error("Failed to download audio");
            }
        } finally {
            setIsDownloadingAudio(false);
        }
    };

    return (
        <>
            <button
                onClick={() => window.history.back()}
                style={{
                    marginBottom: "10px",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "monospace",
                    fontSize: "18px",
                    color: "#007bff",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    borderRadius: "8px 8px 0 0",
                    backgroundColor: "#fff",
                }}
            >
                <span style={{ marginRight: "8px" }}>&lt;</span>
                <span style={{ position: "relative", display: "inline-block" }}>
                    Back
                    <span
                        style={{
                            content: "''",
                            position: "absolute",
                            left: 0,
                            bottom: -2,
                            width: "100%",
                            height: "1px",
                            borderBottom: "2px solid #007bff",
                        }}
                    ></span>
                </span>
            </button>

            <div className="container">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center gap-2">
                        <h4 className="fw-bold m-0">Booking Details</h4>
                        {booking?.abusiveCount !== undefined && booking?.abusiveCount !== null && Number(booking.abusiveCount) > 0 && (
                            <span
                                className="badge bg-danger text-white px-2 py-1 rounded-pill"
                                style={{ fontSize: "12px", fontWeight: 600 }}
                            >
                                <i className="icofont-warning-alt me-1"></i>
                                {booking.abusiveCount} Abusive Flagged
                            </span>
                        )}
                    </div>
                    {/* {booking.bookingType === "chat" && ( */}
                    <button
                        className={`btn btn-sm ${booking?.bookingStatus !== "completed" ? "btn-outline-primary" : "btn-primary"}`}
                        onClick={() =>
                            booking?.bookingStatus === "completed" &&
                            navigate(`/chat-history/${userId}/${astroId}`, {
                                state: {
                                    userName: booking?.userName,
                                    astroName: booking?.astroName,
                                },
                            })
                        }
                        disabled={booking?.bookingStatus !== "completed"}
                        title={booking?.bookingStatus !== "completed" ? "Chat history available after completion" : ""}
                    >
                        View Chat History
                    </button>

                    {/* )} */}
                </div>
                <div className="card shadow-sm">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-6"><strong>Booking ID:</strong> {booking?.orderId}</div>
                            <div className="col-md-6"><strong>User Name:</strong> {booking?.userName}</div>
                            <div className="col-md-6"><strong>Astrologer Name:</strong> {booking?.astroName}</div>
                            <div className="col-md-6"><strong>Booking Type:</strong> {formatCamelCase(booking?.bookingType)}</div>
                            <div className="col-md-6"><strong>Created At:</strong> {booking?.bookingTimeFormatted}</div>
                            <div className="col-md-6"><strong>Booking Price:</strong> {booking?.bookingPrice}</div>
                            {/* <div className="col-md-6">
                            <strong>Booking Start Time:</strong>{" "}
                            {booking?.startTime ? new Date(booking.startTime).toLocaleDateString("en-GB").replace(/\//g, "-") : "N/A"}
                        </div> */}
                            <div className="col-md-6">
                                <strong>Booking Start Time:</strong>{" "}
                                {booking?.startTime &&
                                    new Date(booking.startTime).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                        year: "numeric",
                                        month: "short",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    })}
                            </div>


                            {(booking?.bookingType === "call" || booking?.bookingType === "chat") && (
                                <div className="col-md-6">
                                    <strong>Per Minute Price:</strong> {booking?.perMinPrice}
                                </div>
                            )}

                            {booking?.bookingType !== "audio" &&
                                booking?.bookingType !== "chat" &&
                                booking?.reason &&
                                booking?.reason !== "N/A" && (
                                    <div className="col-md-6"><strong>Reason:</strong> {booking?.reason}</div>
                                )}

                            <div className="col-md-6"><strong>Booking Status:</strong> {booking?.bookingStatus}</div>

                            {/* {(booking.bookingType !== "audio" && booking.bookingType !== "chat") ? (
                            <div className="col-md-6"><strong>Total Duration:</strong> {booking.totalDuration}</div>
                        ) : (
                            Number(booking.totalDuration) > 45 && (
                                <div className="col-md-6"><strong>Total Duration:</strong> {booking.totalDuration} sec</div>
                            )
                        )} */}
                            {(booking.bookingType !== "audio" && booking.bookingType !== "chat") ? (
                                <div className="col-md-6">
                                    <strong>Total Duration:</strong> {convertSecondsToTime(Number(booking.totalDuration))}
                                </div>
                            ) : (
                                Number(booking.totalDuration) > 45 && (
                                    <div className="col-md-6">
                                        <strong>Total Duration:</strong> {convertSecondsToTime(Number(booking.totalDuration))}
                                    </div>
                                )
                            )}


                            <div className="col-md-6"><strong>Total Deduction:</strong> {booking.totalDeduction}</div>
                            <div className="col-md-6">
                                <strong>Actual Deduction:</strong> {Number(booking.actualDeduction).toFixed(2)}
                            </div>
                            <div className="col-md-6"><strong>Promotional Deduction:</strong> {booking.promotionalDeduction}</div>
                            <div className="col-md-6">
                                <strong>Abusive Count:</strong>{" "}
                                {booking?.abusiveCount !== undefined && booking?.abusiveCount !== null ? (
                                    Number(booking.abusiveCount) > 0 ? (
                                        <span className="badge bg-danger text-white px-2 py-1 rounded-pill">
                                            <i className="icofont-warning-alt me-1"></i>
                                            {booking.abusiveCount} Flagged
                                        </span>
                                    ) : (
                                        <span
                                            className="badge rounded-pill px-2 py-1"
                                            style={{
                                                backgroundColor: "#e8f5e9",
                                                color: "#2e7d32",
                                                border: "1px solid #c8e6c9",
                                                fontWeight: 600,
                                            }}
                                        >
                                            <i className="icofont-check-circled me-1"></i>
                                            0
                                        </span>
                                    )
                                ) : (
                                    "0"
                                )}
                            </div>

                            {/* Audio Player & Download Section */}
                            {booking?.bookingType.toLowerCase() === "call" && <div className="col-12 mt-4 pt-3 border-top">
                                <div className="p-3 bg-light rounded-3 border d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                                    <div className="d-flex align-items-center gap-3 flex-grow-1">
                                        <div
                                            className={`d-flex align-items-center justify-content-center text-white rounded-circle flex-shrink-0 ${booking?.audioUrl ? 'bg-primary' : 'bg-secondary'}`}
                                            style={{ width: "42px", height: "42px" }}
                                        >
                                            <BsMusicNoteBeamed size={20} />
                                        </div>
                                        <div className="flex-grow-1" style={{ maxWidth: "550px" }}>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <strong className="text-secondary small">Audio Recording</strong>
                                                {!booking?.audioUrl && (
                                                    <span className="badge bg-secondary">Not Available</span>
                                                )}
                                            </div>
                                            <audio
                                                controls
                                                src={booking?.audioUrl || ""}
                                                className="w-100"
                                                style={{ height: "40px" }}
                                            >
                                                Your browser does not support the audio element.
                                            </audio>
                                        </div>
                                    </div>
                                    {isSuperAdmin ? <div className="flex-shrink-0">
                                        {booking?.audioUrl ? (
                                            <button
                                                type="button"
                                                className="btn btn-primary d-flex align-items-center gap-2 px-3 py-2"
                                                onClick={() => handleDownloadAudio(booking.audioUrl)}
                                                disabled={isDownloadingAudio}
                                            >
                                                {isDownloadingAudio ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        <span>Downloading...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <BsDownload size={16} />
                                                        <span>Download Audio</span>
                                                    </>
                                                )}
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary d-flex align-items-center gap-2 px-3 py-2"
                                                disabled
                                                title="Audio not available for download"
                                            >
                                                <BsDownload size={16} />
                                                <span>Download Audio</span>
                                            </button>
                                        )}
                                    </div> : <></>}
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default BookingDetails;

